import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

export const GrossVehicleWeightMin = withFacetContext(
    FacetName.gross_vehicle_weight,
    withFilterContext(FilterName.min_gross_vehicle_weight, SearchFiltersDropdown, {
        ...rangeMin,
        ariaLabel: ariaLabel.gvw.min,
    })
)
export const GrossVehicleWeightMax = withFacetContext(
    FacetName.gross_vehicle_weight,
    withFilterContext(FilterName.max_gross_vehicle_weight, SearchFiltersDropdown, {
        ...rangeMax,
        ariaLabel: ariaLabel.gvw.max,
    })
)
